// GECICI DOSYA — Forensics bitince silinecek
// Amac: reconstruction sirasinda bug teshisi icin log toplama
const FORENSICS_ENABLED = false;

export function flog(label, data) {
  if (!FORENSICS_ENABLED) return;
  try {
    console.log(`[FORENSICS:${label}] ${JSON.stringify(data)}`);
  } catch {
    console.log(`[FORENSICS:${label}]`, data);
  }
}
